const PERMISSION = {
	AGENCY: {
		CONTACTS_VIEW: 'CONTACTS.VIEW',
		CONTACTS_CREATE: 'CONTACTS.CREATE',
		CONTACTS_EDIT: 'CONTACTS.EDIT',
		CHANGE_STATUS: 'CONTACTS.CHANGE_STATUS',
		ENABLE_CLAIM_NOTIFICATIONS: 'CONTACTS.ENABLE_CLAIM_NOTIFICATIONS'
	},
	BONUS: 'PORTAL.BONUS',
	CANCEL: 'PORTAL.CANCEL',
	CDPH530: 'PORTAL.CDPH530.SEND_EMAIL',
	DISPUTES: 'PORTAL.DISPUTES',
	DNR: 'PORTAL.SETTINGS.DNR',
	EDIT: 'PORTAL.EDIT',
	EDIT_ASSIGNMENT: 'PORTAL.EDIT.ASSIGNMENT',
	EDIT_WAGE: 'PORTAL.EDIT.WAGE',
	FACILITY_INFO: 'PORTAL.SETTINGS.FACILITY_INFO',
	GUARANTEE: 'PORTAL.GUARANTEE',
	INVITE: 'PORTAL.SETTINGS.CAREGIVER_INVITE',
	PAST_SHIFTS: 'PORTAL.SHIFTS.PAST',
	PROFESSIONALS: 'PORTAL.FEATURES.PROFESSIONALS',
	INTERNAL_STAFF: 'PORTAL.FLEX.INTERNAL_STAFF',
	SIGNATURE_RULE: 'PORTAL.SETTINGS.SIGNATURE_RULE',
	SETTINGS: 'PORTAL.SETTINGS',
	FLEX_ADD_CAREGIVER: 'PORTAL.FLEX.ADD_CAREGIVER',
	FLEX_ADD_EDIT_SHIFT: 'PORTAL.FLEX.ADD_EDIT_SHIFT',
	FLEX_CANCEL: 'PORTAL.FLEX.CANCEL',
	REPORTS: 'REPORTS',
	FLEX_ASSIGN_UNITS: 'PORTAL.FLEX.EDIT.UNIT.ASSIGNMENT',
	PORTAL_EDIT_SHIFT_ROUTING: 'PORTAL.EDIT.SHIFT_ROUTING',
	WORKFORCE_VIEW: 'WORKFORCE_PAGE.ACTION.VIEW',
	WORKFORCE_PROFESSIONAL_EDIT: 'WORKFORCE_PAGE.PROFESSIONAL.EDIT',
	WORKFORCE_PROFESSIONAL_VIEW: 'WORKFORCE_PAGE.PROFESSIONAL.PROFILE.VIEW',
	WORKFORCE_CREDENTIALS_VIEW: 'WORKFORCE.EMPLOYEE.CREDENTIALS.VIEW',
	WORKFORCE_CREDENTIALS_EDIT: 'WORKFORCE.EMPLOYEE.CREDENTIALS.EDIT',
	WORKFORCE_CREDENTIALS_DOWNLOAD: 'WORKFORCE.EMPLOYEE.CREDENTIALS.DOWNLOAD',
	WORKFORCE_DOWNLOAD: 'WORKFORCE_PAGE.ACTION.DOWNLOAD',
	WORKFORCE_CREDENTIALS_DELETE: 'WORKFORCE.EMPLOYEE.CREDENTIALS.DELETE',
	WORKFORCE_LOCATIONS_VIEW: 'WORKFORCE.EMPLOYEE.LOCATIONS.VIEW',
	WORKFORCE_LOCATIONS_EDIT: 'WORKFORCE.EMPLOYEE.LOCATIONS.EDIT',
	WORKFORCE_NOTES_VIEW: 'WORKFORCE.EMPLOYEE.NOTES.VIEW',
	WORKFORCE_NOTES_EDIT: 'WORKFORCE.EMPLOYEE.NOTES.EDIT',
	SETTINGS_PAGE_VIEW: 'SETTINGS.PAGE.VIEW',
	SETTINGS_NOTIFICATIONS_EDIT: 'SETTINGS.NOTIFICATIONS.EDIT'
};

export default PERMISSION;
